import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import {
  initHeycatch,
  applyHeycatchConsent,
  handleHeycatchStorageChange,
} from "@/lib/heycatchAnalytics";

// Boot HeyCatch analytics before React renders so autocapture is set up.
// Fails silently if REACT_APP_HEYCATCH_PROJECT_KEY is not configured —
// no SDK code runs and no network request is made.
if (initHeycatch()) {
  window.addEventListener("storage", handleHeycatchStorageChange);
  // Modern same-tab consent-change event dispatched by CookieSettings.jsx.
  window.addEventListener("zy:analytics-consent-changed", () => {
    applyHeycatchConsent(true);
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

